
import { useState, useEffect } from 'react';
import { getApiBaseUrl } from '@/utils/configService';

// Helper function to increment scan counter - only updates local count
export const incrementScanCounter = async () => {
  try {
    // Dispatch the custom event for local state update
    const event = new Event('scanCompleted');
    window.dispatchEvent(event);
    
    console.log("Local scan counter updated");
  } catch (error) {
    console.error("Error updating local scan counter:", error);
  }
};

// Create a custom hook to manage the scan counter
export const useScanCounter = () => {
  const [scanCount, setScanCount] = useState(1312);
  
  useEffect(() => {
    // Check localStorage for any saved count
    const savedCount = localStorage.getItem('totalScanCount');
    if (savedCount) {
      setScanCount(parseInt(savedCount, 10));
    }
    
    // Fetch the latest count from API endpoint
    const fetchLatestCount = async () => {
      try {
        const response = await fetch(`${getApiBaseUrl()}/counter`);
        if (response.ok) {
          const data = await response.json();
          if (data.Message && typeof data.Message === 'string') {
            const count = parseInt(data.Message, 10);
            if (!isNaN(count)) {
              setScanCount(count);
              localStorage.setItem('totalScanCount', count.toString());
            }
          }
        }
      } catch (error) {
        // Silently fail, just use the local stored count
        console.log("Using local count");
      }
    };
    
    fetchLatestCount();
    
    // Listen for custom events when scans are completed
    const handleScanCompleted = () => {
      const newCount = scanCount + 1;
      setScanCount(newCount);
      localStorage.setItem('totalScanCount', newCount.toString());
    };
    
    window.addEventListener('scanCompleted', handleScanCompleted);
    
    return () => {
      window.removeEventListener('scanCompleted', handleScanCompleted);
    };
  }, [scanCount]);
  
  return scanCount;
};
